import {
  KeyboardArrowDown,
  Edit,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "../../../assets/img/no-record.png";
import DeletePrompt from "../../Common/DeletePrompt";
import { Field, Form, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as message from "../../../config/CommonMessages";
import {
  addBillingItems,
  getAllBillingItems,
  editBillingItems,
} from "../../../actions/BillingActions";
import * as code from "../../../config/Constants";
import { getUserRolesActionNew } from "../../../actions/UserActions";

class BillingItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Billing Items",
      showAddModal: false,
      showEditPrompt: false,
      billingItemCode: "",
      billingItemDesc: "",
      Isactive: false,
      editIsactive: false,
      billingItems: [],
      editId: "",
      itemCodeduplicat: false,
      Isroleitem: false,
      roles: [],
    };
  }
  columns = [
    {
      name: "Billing Item Desc",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "Billing Item Code",
      selector: "shortcode",
      sortable: true,
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "Status",
      selector: "status",
      //sortable: true,
      ignoreRowClick: true,
      width: "10%",
    },
    {
      name: "CreatedBy",
      selector: "createdby",
      sortable: true,
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "ModifiedBy",
      selector: "modifiedby",
      ignoreRowClick: true,
      width: "20%",
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];

  openAddModal() {
    this.setState({
      showAddModal: true,
    });
  }

  componentWillMount() {
    this.getallBillingitems();
    this.getalluserroles();
  }

  getalluserroles() {
    this.setState({
      showLoader: true,
    });
    this.props.getUserRolesActionNew().then((result) => {
      this.setState({
        roles: result,
        showLoader: false,
      });
      // console.log("result119", result);
    });
  }

  getallBillingitems() {
    this.setState({
      showLoader: true,
    });
    this.props.getAllBillingItems().then((result) => {
      this.setState({
        billingItems:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data
            : [],
        showLoader: false,
      });
    });
  }
  openEditPrompt(billingItem) {
    // console.log("billingItem", billingItem);
    this.setState({
      showEditPrompt: true,
      editId: billingItem._id,
      billingItemCode: billingItem.billingItemCode,
      Isroleitem: billingItem.Isroleitem,
      billingItemDesc: billingItem.billingItemDesc,
      editIsactive: billingItem.Isactive,
    });
  }
  addBillingItems(values) {
    this.props
      .addBillingItems(values)
      .then((res) => {
        if (res.status === code.OK) {
          this.setState({
            showAddModal: false,
            billingItemCode: "",
            billingItemDesc: "",
            Isactive: false,
            Isroleitem: false,
            itemCodeduplicat: false,
          });
          this.getallBillingitems();
        } else {
          if (res.data === "duplicate") {
            this.setState({
              itemCodeduplicat: true,
            });
          }
        }
      })
      .catch((err) => {});
  }
  editBillingItems(values) {
    this.props
      .editBillingItems(values)
      .then((res) => {
        this.setState({
          showEditPrompt: false,
          billingItemCode: "",
          billingItemDesc: "",
          Isactive: false,
          editId: "",
        });
        this.getallBillingitems();
      })
      .catch((err) => {});
  }

  render() {
    let rows = [];
    for (var i = 0, len = this.state.billingItems.length; i < len; i++) {
      let billingItems = this.state.billingItems[i];
      let data = {
        name: billingItems.billingItemDesc,
        shortcode: billingItems.billingItemCode,

        status: billingItems.Isactive ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),

        createdby: billingItems.createdby ? billingItems.createdby : "",
        modifiedby: billingItems.modifiedby ? billingItems.modifiedby : "",

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.openEditPrompt(billingItems);
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col align="right">
            <Button
              onClick={() => {
                this.openAddModal();
              }}
              className="btn btn-primary btn-blue btn-head w-140"
            >
              Add
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.contingencyID}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.deleteContingency}
            />

            <Modal
              show={this.state.showAddModal}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Add Billing Item
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <Formik
                  validateOnBlur={true}
                  initialValues={this.state}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    billingItemCode: Yup.string()
                      .trim()
                      .required(message.ENTER_BILLING_ITEM_CODE)
                      .max(20, message.MAX_BILLING_ITEM),
                    billingItemDesc: Yup.string()
                      .trim()
                      .required(message.ENTER_BILLING_ITEM_DESC),
                  })}
                  onSubmit={(values) => {
                    let data = {
                      billingItemCode: values.billingItemCode
                        .toLowerCase()
                        .trim()
                        .split(" ")
                        .join(""),
                      billingItemDesc: values.billingItemDesc.trim(),
                      Isactive: values.Isactive,
                      Isroleitem: values.Isroleitem,
                      createdby: localStorage.getItem("userName"),
                    };
                    this.addBillingItems(data);
                  }}
                >
                  <Form
                    className="form-sm form-admin"
                    style={{ marginBottom: 15 }}
                  >
                    <div className="form-group">
                      <Field
                        type="checkbox"
                        name="Isroleitem"
                        value={this.state.Isroleitem}
                        onChange={(e) => {
                          this.setState({
                            Isroleitem: !this.state.Isroleitem,
                            billingItemCode: "",
                          });
                        }}
                        style={{ marginRight: 5 }}
                      />
                      <label
                        htmlFor="setIsParticipant"
                        className="form-check-label"
                        style={{ paddingRight: 26 }}
                      >
                        Is Role Billing Item?
                      </label>
                      <ErrorMessage
                        name="Isroleitem"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        Billing Item Code<span className="text-danger"> *</span>
                      </label>
                      {this.state.Isroleitem ? (
                        <div className="c-select">
                          <select
                            className="form-control form-control-sm"
                            style={{
                              width: "100%",
                              textTransform: "none",
                            }}
                            onChange={(e) => {
                              this.setState({
                                billingItemCode: e.target.value,
                              });
                            }}
                            value={this.state.billingItemCode}
                          >
                            <option value="">Select Role</option>
                            {this.state.roles &&
                              this.state.roles.map((role) => {
                                return (
                                  <option
                                    key={role.itemCode}
                                    value={role.itemCode}
                                  >
                                    {role.itemCode}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      ) : (
                        <Field
                          type="text"
                          className="form-control"
                          name="billingItemCode"
                          onChange={(e) => {
                            this.setState({ billingItemCode: e.target.value });
                          }}
                        />
                      )}
                      <ErrorMessage
                        name="billingItemCode"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      {this.state.itemCodeduplicat ? (
                        <div className="text-danger">
                          Billing item duplicate
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Item Description<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="billingItemDesc"
                        onChange={(e) => {
                          this.setState({ billingItemDesc: e.target.value });
                        }}
                      />
                      <ErrorMessage
                        name="billingItemDesc"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>

                    <div className="form-group">
                      <Field
                        type="checkbox"
                        name="Isactive"
                        value={this.state.Isactive}
                        onChange={(e) => {
                          this.setState({
                            Isactive: e.target.checked,
                          });
                        }}
                        style={{ marginRight: 5 }}
                      />
                      <label
                        htmlFor="setIsParticipant"
                        className="form-check-label"
                        style={{ paddingRight: 26 }}
                      >
                        Is Active?
                      </label>
                      <ErrorMessage
                        name="Isactive"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Button
                      variant="primary"
                      className="btn-blue w-140"
                      type="submit"
                      style={{ marginRight: 10 }}
                    >
                      Add
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-140"
                      onClick={() => {
                        this.setState({
                          showAddModal: false,
                          billingItemCode: "",
                          billingItemDesc: "",
                          Isactive: false,
                          itemCodeduplicat: false,
                          Isroleitem: false,
                        });
                      }}
                    >
                      Cancel
                    </Button>
                  </Form>
                </Formik>
              </Modal.Body>
            </Modal>

            {/* Edit Data Modal */}
            <Modal
              show={this.state.showEditPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400"
              backdrop={false}
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Edit Billing Item
                </Modal.Title>
              </Modal.Header>

              <Modal.Body className="pb-0">
                <Formik
                  validateOnBlur={true}
                  initialValues={this.state}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    billingItemCode: Yup.string()
                      .trim()
                      .required(message.ENTER_BILLING_ITEM_CODE),
                    billingItemDesc: Yup.string()
                      .trim()
                      .required(message.ENTER_BILLING_ITEM_DESC),
                  })}
                  onSubmit={(values, errors) => {
                    let data = {
                      billingItemCode: values.billingItemCode
                        .toLowerCase()
                        .trim(),
                      billingItemDesc: values.billingItemDesc.trim(),
                      Isactive: values.editIsactive,
                      modifiedby: localStorage.getItem("userName"),
                      editId: this.state.editId,
                      Isroleitem: this.state.Isroleitem,
                    };
                    this.editBillingItems(data);
                  }}
                >
                  <Form
                    className="form-sm form-admin"
                    style={{ marginBottom: 15 }}
                  >
                    <div className="form-group">
                      <label>
                        Billing Item Code<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="billingItemCode"
                        readOnly
                      />
                      <ErrorMessage
                        name="billingItemCode"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        Item Description<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="billingItemDesc"
                        onChange={(e) => {
                          this.setState({ billingItemDesc: e.target.value });
                        }}
                      />
                      <ErrorMessage
                        name="billingItemDesc"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </div>

                    <div className="form-group">
                      {this.state.editIsactive}
                      <Field
                        type="checkbox"
                        name="Isactive"
                        checked={this.state.editIsactive}
                        onChange={(e) => {
                          this.setState({
                            editIsactive: e.target.checked,
                          });
                        }}
                        style={{ marginRight: 5 }}
                      />
                      <label
                        htmlFor="setIsParticipant"
                        className="form-check-label"
                        style={{ paddingRight: 26 }}
                      >
                        Is Active?
                      </label>
                      <ErrorMessage
                        name="Isactive"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <Button
                      variant="primary"
                      className="btn-blue w-140"
                      type="submit"
                      style={{ marginRight: 10 }}
                    >
                      Update
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-140"
                      onClick={() => {
                        this.setState({
                          billingItemCode: "",
                          billingItemDesc: "",
                          Isactive: false,
                          showEditPrompt: false,
                        });
                      }}
                    >
                      Cancel
                    </Button>
                  </Form>
                </Formik>
              </Modal.Body>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    addBillingItems,
    getAllBillingItems,
    editBillingItems,
    getUserRolesActionNew,
  }
)(BillingItems);
